import React from "react";
import IPage from "../../interfaces/page"
import BookComponent from "../../components/Book/Book.component";

const BookPage: React.FunctionComponent<IPage> = (props: IPage) => {
    return <BookComponent></BookComponent>;
};

export default BookPage;
